import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { getTaskDetail, postTask, updateTask } from '@blade-sxp/task-management/api/creat-task/index';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import httpConfidence from '@blade-sxp/task-management/components/http-confidence.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
let FaceVehicleTask = class FaceVehicleTask extends Vue {
    loading = true;
    isDetail = false;
    isReady = false;
    isError = false;
    disableRight = true;
    id = '';
    type = 'add';
    taskType = 'FACE_ATTRIBUTE';
    httpUrl = '';
    name = '';
    status = 'ENABLE';
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    remark = '';
    get formData() {
        const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, httpUrl, isReady } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            httpUrl,
        };
    }
    init() {
        this.clearData();
        const { type, id, taskType } = this.$route.query;
        if (!type) {
            this.$message.error(`${this.$t('common.unknownError')}`);
        }
        this.type = type;
        this.id = id;
        this.taskType = taskType;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            this.isReady = true;
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm() {
        if (this.isDetail) {
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 2; i++) {
            if (this.$refs['formItem' + i]) {
                let res = await this.$refs['formItem' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    clearData() {
        this.loading = true;
        this.isDetail = false;
        this.isReady = false;
        this.isError = false;
        this.disableRight = true;
        this.id = '';
        this.type = 'add';
        this.taskType = 'FACE_ATTRIBUTE';
        this.name = '';
        this.status = 'ENABLE';
        this.effectivePeriod = 'PERMANENT';
        this.effectiveDates = {
            start: '',
            end: '',
        };
        this.effectiveTimes = [{ start: '', end: '' }];
        this.dayOfWeeks = [];
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const req = {
            taskName: this.name,
            remark: this.remark,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    url: this.httpUrl,
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                    },
                ],
            },
            deviceTaskConfigs: this.formatPortraitToData(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            postTask(req).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            updateTask({ taskId: this.id, ...req }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    getData() {
        getTaskDetail(Number(this.id)).then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (notifyConfig) {
                this.httpUrl = notifyConfig.url;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
            }
            if (!isEmpty(deviceTaskConfigs)) {
                deviceTaskConfigs.forEach((item) => {
                    DeviceIdDataModule?.deviceIdRequestParams.set(item.deviceId, { zoneId: item.zoneId, deviceId: item.deviceId });
                });
            }
            this.loading = false;
        });
    }
    formatPortraitToData() {
        const incidentType = plotMap.get(this.taskType).incidentType;
        const requestData = DeviceIdDataModule?.deviceIdRequestParams;
        let formatData = [];
        if (!isEmpty(incidentType) && !isEmpty(requestData)) {
            DeviceIdDataModule?.deviceIdRequestParams.forEach((item) => {
                formatData.push({
                    ...item,
                    incidentType,
                });
            });
        }
        return formatData;
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], FaceVehicleTask.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true })
], FaceVehicleTask.prototype, "validForm", null);
FaceVehicleTask = __decorate([
    Component({
        name: 'FaceVehicleTask',
        components: {
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'button-box': ButtonBox,
            'device-darwer': DeviceDarwer,
            'http-confidence': httpConfidence,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                },
            },
        },
    })
], FaceVehicleTask);
export default FaceVehicleTask;
